export const environment = {
  apiGatewayConfig: {
    apiGatewayUrl: 'https://api-gateway-dev.drcedirect.com/',
    apiGatewayCloudUrl: 'https://api-gateway-cloud-dev.drcedirect.com',
    client: 'all',
    deployment: 'development',
    version: 'v0',
    enableCache: true,
    dynatraceConfig: {
      scriptUrl: 'https://js-cdn.dynatrace.com/jstag/17b628055ae/bf63792rhe/de837b5f50dcdf20_complete.js'
    }
  },
  production: false,
  okta: {
    clientConfig: {
      issuer: 'https://auth-dev.drcedirect.com/oauth2/default',
      clientId: 'eca-portal',
      redirectUri: 'https://cdn-app-dev.drcedirect.com',
      pkce: true,
      scopes: ['profile', 'openid', 'okta.myAccount.password.read', 'okta.myAccount.password.manage'],
      tokenManager: {
        secure: true,
        storage: 'sessionStorage'
      }
    },
    samlRedirectUrl: 'https://auth-dev.drcedirect.com/app/datarecognitioncorporation_ecainsightportal_2/exkip20oIYUuce4Zr1d5/sso/saml'
  },
  islandBrowserUrl: '',
  userManagementUrl: 'https://dev.uum-le.drcedirect.com',
  serviceNowUrl: 'https://datarecognitioncorpdev.service-now.com/customerserviceportal2?id=csp2_connect_chat',
  genesys: {
    deploymentId: '37a742bf-b5a0-47af-b552-d211ab3d8a44',
    environment: 'usw2',
    orgGuid: '4e8196cb-bd36-4309-9008-eea81adb60b3',
    script: 'https://apps.usw2.pure.cloud/genesys-bootstrap/genesys.min.js'
  },
  confluenceUrl: 'https://eps-dev.awcl.drcedirect-le.com/api/v1/docs',
  ecaPortalServiceUrl: 'https://eps-dev.awcl.drcedirect-le.com/api/v1',
  userAttributeServiceUrl: 'https://uatt-dev.awcl.drcedirect-le.com',
  useNewLoginPage: true
};
